import clearQuotes from '@/utils/clearQuotes'
import trimTrailingSpaces from '@/utils/trimTrailingSpaces'
import type {FollowUpPromptsV2} from '@/views/Chat/types'

import mergeEscapeStrings from './mergeEscapeStrings'

const followUpPromptsBeginTexts = '```csv\n'

export default function getFollowUpPrompts2FromMessage(
  message: string,
  foundFollowUpPrompts = false,
  prompts: FollowUpPromptsV2,
): string {
  if (!foundFollowUpPrompts) {
    // Looking for begin of follow up prompts type2
    const beginFollowUpPos = message.indexOf(followUpPromptsBeginTexts)
    if (beginFollowUpPos !== -1) {
      // Found follow up prompts section
      const messageBeforeFollowUpPrompts = message.slice(0, beginFollowUpPos)
      // Message after the begin
      const messageFromFollowUpPrompts = message.slice(
        beginFollowUpPos + followUpPromptsBeginTexts.length,
      )
      // console.log('Before', [messageBeforeFollowUpPrompts])
      // console.log('After', [messageFromFollowUpPrompts])
      // console.log('Found follow up prompts section', [message])
      // Found followup prompts section to keep parsing the message from after the header
      return (
        messageBeforeFollowUpPrompts +
        getFollowUpPrompts2FromMessage(messageFromFollowUpPrompts, true, prompts)
      )
    }
    // cannot found any follow up prompts section
    // console.log('Cannot find any more', [message])
    return message
  }
  // Already found
  const testTextLineEnding = message.indexOf('\n')

  if (testTextLineEnding !== -1) {
    if (message.slice(0, testTextLineEnding) === '```') {
      // Found follow up prompts ending
      // console.log('End follow up prompts section', [message])
      const messageAfterFollowUpPrompt = message.slice(4)
      return getFollowUpPrompts2FromMessage(messageAfterFollowUpPrompt, false, prompts)
    }
    // Found follow up prompt ending
    // console.log('Found follow up questions', [message])

    const followUpPromptText = message.slice(0, testTextLineEnding)
    const followUpPromptTextSplited = mergeEscapeStrings(followUpPromptText.split(',')).map(
      prompt => clearQuotes(trimTrailingSpaces(prompt)),
    )

    prompts.push(...followUpPromptTextSplited)

    // Then continue to check
    const messageAfterFollowUpPrompt = message.slice(testTextLineEnding + 1)
    getFollowUpPrompts2FromMessage(messageAfterFollowUpPrompt, true, prompts)
    return ''
  }
  return ''
}
